// @ts-check
if (!customElements.get('ff-accordion')) {
  class FfAccordion extends HTMLElement {
    constructor() {
      super();
      /** @type {HTMLElement|null} */
      this.ffTrigger = null;
      /** @type {HTMLElement|null} */
      this.ffContent = null;
      /** @type {boolean} */
      this._ffInitialized = false;
      this.ffHandleTransitionEnd = this.ffHandleTransitionEnd.bind(this);
      this.ffHandleClick = this.ffHandleClick.bind(this);
      this.ffInit();
    }

    ffHandleClick() {
      const isOpen = this.ffTrigger?.getAttribute('aria-expanded') === 'true';
      this.ffToggle(!isOpen);
    }

    ffInit() {
      this.id = this.dataset.ffAccordionId;
      this.ffTrigger = this.querySelector(`[data-ff-accordion-trigger][data-ff-accordion-id="${this.id}"]`);
      this.ffContent = this.querySelector(`[data-ff-accordion-content][data-ff-accordion-id="${this.id}"]`);
      if (!this.id) return;

      if (!this.ffTrigger || !this.ffContent) return;

      this.ffSetTransition();

      // Prevent duplicate event listeners
      if (!this._ffInitialized) {
        this._ffInitialized = true;
        this.ffTrigger.addEventListener('click', this.ffHandleClick);
      }
    }

    /**
     * @param {boolean} open
     */
    ffToggle(open) {
      this.ffTrigger = this.querySelector(`[data-ff-accordion-trigger][data-ff-accordion-id="${this.id}"]`);
      this.ffContent = this.querySelector(`[data-ff-accordion-content][data-ff-accordion-id="${this.id}"]`);
      if (!this.ffTrigger || !this.ffContent) return;

      this.ffTrigger.setAttribute('aria-expanded', String(open));
      this.ffTrigger.classList.toggle('ff-collapsible-tab-active', open);
      this.ffContent.classList.toggle('ff-accordion--active', open);
      this.ffSetTransition();

      if (open) {
        this.classList.add('ff-accordion--opening');
        this.ffContent.style.height = this.ffContent.scrollHeight + 'px';
        this.ffContent.addEventListener('transitionend', this.ffHandleTransitionEnd);
      } else {
        this.classList.remove('ff-accordion--opening');
        this.ffContent.style.height = this.ffContent.scrollHeight + 'px';
        // Force reflow before animating to 0
        this.ffContent.offsetHeight;
        this.ffContent.style.height = '0px';
        this.ffCloseNested();
      }
    }

    /**
     * @param {TransitionEvent} e
     */
    ffHandleTransitionEnd(e) {
      // Only handle height transition on this content (not children)
      if (e.propertyName !== 'height' || e.target !== this.ffContent || !this.ffContent) return;
      this.ffContent.removeEventListener('transitionend', this.ffHandleTransitionEnd);
      this.classList.remove('ff-accordion--opening');
      this.ffContent.style.height = 'auto';
    }

    ffClose() {
      this.ffToggle(false);
    }

    ffCloseNested() {
      if (!this.ffContent) return;
      this.ffContent.querySelectorAll('ff-accordion').forEach(nested => {
        // Skip accordions locked by CSS class (e.g., show-more locked by search)
        if (nested.classList.contains('ff-accordion--search-locked')) return;
        /** @type {any} */ (nested).ffClose();
      });
    }

    ffSetTransition() {
      if (!this.ffContent) return;
      const height = this.ffContent.scrollHeight;
      const duration = height * 0.0004 + 0.04;
      this.ffContent.style.transition = `height ${duration}s ease`;
    }
  }

  customElements.define('ff-accordion', FfAccordion);
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('ff-accordion').forEach(acc => /** @type {any} */ (acc).ffInit());
  });
}
